import React from 'react';
import { getDataTrend } from '../utils';
import { Icon } from 'antd';

const iconTypes = {
    seo_score: {
        no_data: null,
        decreased: (
            <Icon
                type="caret-down"
                style={{ color: '#f63842' }}
            />
        ),
        increased: (
            <Icon
                type="caret-up"
                style={{ color: '#34bc6e' }}
            />
        ),
        equal: <Icon type="swap" />,
    },
    backlinks: {
        no_data: null,
        decreased: (
            <Icon
                type="caret-down"
                style={{ color: '#f63842' }}
            />
        ),
        increased: (
            <Icon
                type="caret-up"
                style={{ color: '#34bc6e' }}
            />
        ),
        equal: <Icon type="swap" />,
    },
    loading_time: {
        no_data: null,
        decreased: (
            <Icon
                type="caret-down"
                style={{ color: '#34bc6e' }}
            />
        ),
        increased: (
            <Icon
                type="caret-up"
                style={{ color: '#f63842' }}
            />
        ),
        equal: <Icon type="swap" />,
    },
};

type Props = {
    resourceType: 'seo_score' | 'backlinks' | 'loading_time';
    currentValue?: number;
    comparedTo?: number;
};

export default function TrendIcon({ resourceType, currentValue, comparedTo }: Props) {
    return iconTypes[resourceType][getDataTrend(currentValue, comparedTo)];
}
